import React from 'react'
import Users from '../components/Users'

const UsersPage = () => <Users />

export default UsersPage
